// extracted by mini-css-extract-plugin
export default {"container":"AuthorizationStep_container__RnJpB","title":"AuthorizationStep_title__ntOpN","text":"AuthorizationStep_text__+el5o"};